import type { IApiRoutes } from '../ApiRoutes';
import type { GeodataDataType } from '@visualizer/types';
import { getEnvStore } from '../EnvStore';
import { getResourceStore } from '../ResourceStore';

const sceneName = () => getResourceStore().demoSceneName || getEnvStore().gridIdFromQuery;

export const DemoApiRoutes: IApiRoutes = {
    gridDownload(): string {
        return `demo/${sceneName()}/geodata/grid/download`;
    },

    geodataDownload(_geodataId: string, dataType: GeodataDataType): string {
        const GEODATA_TYPE_TO_KIND: Record<string, string> = {
            ground: 'ground',
            vegetation: 'vegetation',
            buildings: 'buildings',
            roads: 'roads',
            target: 'targets',
        };

        const kind = GEODATA_TYPE_TO_KIND[dataType];
        if (!kind) throw new Error(`Unsupported geodata endpoint kind: ${dataType}`);
        return `demo/${sceneName()}/geodata/${kind}/download`;
    },

    raysDownload(_simulationSetId: string, subSimulationId: number): string {
        return `/api/demo/${sceneName()}/simulation/${subSimulationId}/rays/download`;
    },

    resultDownload(_simulationSetId: string, subSimulationId: number, resultId: number): string {
        return `demo/${sceneName()}/simulation/${subSimulationId}/results/${resultId}/download`;
    },

    resultsList(_simulationSetId: string, subSimulationId: number): string {
        return `demo/${sceneName()}/simulation/${subSimulationId}/results`;
    },

    canUseApi(): boolean {
        return false;
    },
};
